import { jsx as _jsx } from "react/jsx-runtime";
// Стопка тостов панели помощи — HelpDrawer/TicketView кита сами формируют tone/title/body
// (см. onToast в kit-v5/templates/help.jsx, help-tickets.jsx), здесь только каркас-хост:
// кит объявляет Toast, но не ToastHost (шаблон-стаб «planned for v5»).
import { Toast } from "@kit-v5";
import "./help-toasts.css";
export default function HelpToasts({ toasts, onDismiss }) {
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: "shell-help-toasts", children: toasts.map((tst) => (_jsx(Toast, { tone: tst.tone, title: tst.title, body: tst.body, onDismiss: () => onDismiss(tst.id) }, tst.id))) }));
}
